import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Switch from "react-switch";
import "../../_Content/css/parametrosAuditoria.css"
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';

const idUsuario = localStorage.getItem("CodUsuario");
const isPro = localStorage.getItem("isPro") === 'true';
const token = localStorage.getItem("Token");
const isSimulacao = localStorage.getItem("isSimulacao") === 'true';

var Parametro = function (parametro, vlrParametro) {
    this.id = 0;
    this.idUsuario = idUsuario + token;
    this.emParametro = parametro;
    this.blAtivo = vlrParametro;
    this.idGeral = 0;
}

class ParametrosAuditoria extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllTheFuckingThings: false,
            basicaFiscal: true,
            inteligenteFiscal: false,
            estadosFiscal: false,
            basicaCont: true,
            inteligenteCont: false,
            basicaEcf: true,
            inteligenteEcf: false,
            basicaEcd: true,
            inteligenteEcd: false,
            modal: false
        }
        this.prepararRequestData();
    }

    static contextTypes = {
        router: () => true,
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    requestData = () => {
        return new Promise((resolve, reject) => {
            let url = `${Config.urls.API_URL_BASE}Parametros/ListarPorUsuario/${idUsuario}`;

            if (token)
                url += '/' + token;

            HttpUtil.eco_GET(url, (response) => {
                resolve({ rows: response.data });
            }, () => { console.log("Error"); });
        })
    }

    handleChange = (checked, event, id) => {

        if (id == "basicaFiscal" && !this.state.basicaFiscal) {
            this.setState({ basicaFiscal: checked });
            localStorage.setItem("basicaFiscal", checked);
        } else if (id == "inteligenteFiscal") {
            this.setState({ inteligenteFiscal: checked });
            localStorage.setItem("inteligenteFiscal", checked);
        }
        else if (id == "estadosFiscal") {
            this.setState({ estadosFiscal: checked });
        }
        else if (id == "basicaCont" && !this.state.basicaCont) {
            this.setState({ basicaCont: checked });
            localStorage.setItem("basicaCont", checked);
        }
        else if (id == "inteligenteCont") {
            this.setState({ inteligenteCont: checked });
            localStorage.setItem("inteligenteCont", checked);
        }
        else if (id == "basica" && !this.state.basicaEcf) {
            this.setState({ basicaEcf: checked });
            localStorage.setItem("basicaEcf", checked);
        }
        else if (id == "inteligenteEcf") {
            this.setState({ inteligenteEcf: checked });
            localStorage.setItem("inteligenteEcf", checked);
        }
        else if (id == "basica" && !this.state.basicaEcd) {
            this.setState({ basicaEcd: checked });
            localStorage.setItem("basicaEcd", checked);
        }
        else if (id == "inteligenteEcd") {
            this.setState({ inteligenteEcd: checked });
            localStorage.setItem("inteligenteEcd", checked);
        }
    }

    prepararRequestData = () => {
        this.requestData().then(res => {
            var icmsBasica = res.rows.filter(item => item.emParametro == "icms_basica")[0];
            var icmsInteligente = res.rows.filter(item => item.emParametro == "icms_inteligente")[0];
            var icmsEstados = res.rows.filter(item => item.emParametro == "icms_estados")[0];
            var contBasica = res.rows.filter(item => item.emParametro == "cont_basica")[0];
            var contInteligente = res.rows.filter(item => item.emParametro == "cont_inteligente")[0];
            var ecfBasica = res.rows.filter(item => item.emParametro == "ecf_basica")[0];
            var ecfInteligente = res.rows.filter(item => item.emParametro == "ecf_inteligente")[0];
            var ecdBasica = res.rows.filter(item => item.emParametro == "ecd_basica")[0];
            var ecdInteligente = res.rows.filter(item => item.emParametro == "ecd_inteligente")[0];

            this.setState({
                basicaFiscal: icmsBasica == undefined ? false : (icmsBasica.blAtivo == 1 ? true : (isPro == true ? true : false)),
                inteligenteFiscal: icmsInteligente == undefined ? false : (icmsInteligente.blAtivo == 1 ? true : (isPro == true ? true : false)),
                estadosFiscal: icmsEstados == undefined ? false : (icmsEstados.blAtivo == 1 ? true : (isPro == true ? true : false)),
                basicaCont: contBasica == undefined ? false : (contBasica.blAtivo == 1 ? true : (isPro == true ? true : false)),
                inteligenteCont: contInteligente == undefined ? false : (contInteligente.blAtivo == 1 ? true : (isPro == true ? true : false)),
                basicaEcf: ecfBasica == undefined ? false : (ecfBasica.blAtivo == 1 ? true : (isPro == true ? true : false)),
                inteligenteEcf: ecfInteligente == undefined ? false : (ecfInteligente.blAtivo == 1 ? true : (isPro == true ? true : false)),
                basicaEcd: ecdBasica == undefined ? false : (ecdBasica.blAtivo == 1 ? true : (isPro == true ? true : false)),
                inteligenteEcd: ecdInteligente == undefined ? false : (ecdInteligente.blAtivo == 1 ? true : (isPro == true ? true : false)),
                showAllTheFuckingThings: true
            })
        });
    };

    salvarInformacoes = () => {
        var listParametro = [];
        listParametro.push(new Parametro('icms_basica', 1));
        listParametro.push(new Parametro('icms_inteligente', this.state.inteligenteFiscal ? 1 : 0));
        listParametro.push(new Parametro('icms_estados', this.state.estadosFiscal ? 1 : 0));
        listParametro.push(new Parametro('cont_basica', 1));
        listParametro.push(new Parametro('cont_inteligente', this.state.inteligenteCont ? 1 : 0));
        listParametro.push(new Parametro('ecf_basica', 1));
        listParametro.push(new Parametro('ecf_inteligente', this.state.inteligenteEcf ? 1 : 0));
        listParametro.push(new Parametro('ecd_basica', 1));
        listParametro.push(new Parametro('ecd_inteligente', this.state.inteligenteEcd ? 1 : 0));

        let url = `${Config.urls.API_URL_BASE}Parametros/Salvar`;

        HttpUtil.eco_POST(url, listParametro, (response) => {
            this.setState({ loading: false });
            this.props.action();
        }, () => { }).then(response => {
            console.log("Ok");
            this.setState({
                modalTitle: "Sucesso",
                modalMessage: "Parâmetros atualizados com sucesso!"
            });
            this.toggle();
        }).catch(response => {
            console.log("Erro");
            this.setState({
                modalTitle: "Erro",
                modalMessage: "Problema ao tentar atualizar os parâmetros, tente novamente mais tarde."
            });
            this.toggle();
        });
    }

    render() {
        return (
            <div>
                <Container style={this.state.showAllTheFuckingThings ? {} : { display: 'none' }}>
                    <Row>
                        <Col>
                            <section className="cabecalho">
                                <Row>
                                    <Col md={12}>
                                        <label className="page-title">Parâmetros de Validação</label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <label>Defina quais parâmetros deseja usar em suas próximas validações ativando as opções abaixo:</label>
                                    </Col>
                                </Row>
                            </section>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card className="parametrosBox">
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <h1>EFD - ICMS IPI</h1>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Básica (Guia)</h2>
                                                    <p>Regras baseadas no GUIA PRÁTICO DA ESCRITURAÇÃO FISCAL DIGITAL</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="basicaFiscal">
                                                <Switch
                                                    id="basicaFiscal"
                                                    onChange={this.handleChange}
                                                    handleDiameter={16}
                                                    onColor="#A8B2BF"
                                                    className={this.state.basicaFiscal ? 'active disabled' : 'inactive'}
                                                    checked={this.state.basicaFiscal}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false}
                                                    disabled={this.state.basicaFiscal} />
                                            </label>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Inteligente (Expertise Econet)</h2>
                                                    <p>A visão do guia pelos especialistas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="inteligenteFiscal">
                                                <Switch
                                                    id="inteligenteFiscal"
                                                    onChange={this.handleChange}
                                                    handleDiameter={16}
                                                    onColor="#6EA6E8"
                                                    className={this.state.inteligenteFiscal ? 'active' : 'inactive'}
                                                    checked={this.state.inteligenteFiscal}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false} />
                                            </label>
                                        </Col>
                                    </Row>
                                    {/*07/12/21 / Diego => parametro retirado a pedido da Viviane de Projetos */}
                                    {/* <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação por Estados (Expertise Econet)</h2>
                                                    <p>A visão do guia pelos especialistas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="estadosFiscal">
                                                <Switch onChange={this.handleChange}
                                                    id="estadosFiscal"
                                                    handleDiameter={16}
                                                    onColor="#d8783e"
                                                    className={this.state.estadosFiscal ? 'active' : 'inactive'}
                                                    checked={this.state.estadosFiscal}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    disabled={true}
                                                    checkedIcon={false} />
                                            </label>
                                        </Col>
                                    </Row> */}
                                </CardBody>
                            </Card>
                        </Col>
                        <Col>
                            <Card className="parametrosBox">
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <h1>EFD - Contribuições</h1>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Básica (Guia)</h2>
                                                    <p>Regras baseadas no GUIA PRÁTICO DA EFD Contribuições </p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className='basicaCont'>
                                                <Switch
                                                    onChange={this.handleChange}
                                                    id="basicaCont"
                                                    className={this.state.basicaCont ? 'active disabled' : 'inactive'}
                                                    disabled={this.state.basicaCont}
                                                    checked={this.state.basicaCont}
                                                    uncheckedIcon={false}
                                                    handleDiameter={16}
                                                    onColor="#A8B2BF"
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false} />
                                            </label>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Inteligente (Expertise Econet)</h2>
                                                    <p>A visão do guia pelos especialistas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className='inteligenteCont'>
                                                <Switch
                                                    onChange={this.handleChange}
                                                    id="inteligenteCont"
                                                    className={this.state.inteligenteCont ? 'active' : 'inactive'}
                                                    checked={this.state.inteligenteCont}
                                                    uncheckedIcon={false}
                                                    handleDiameter={16}
                                                    onColor="#6EA6E8"
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false} />
                                            </label>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Card className="parametrosBox">
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <h1>ECF</h1>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Básica (Guia)</h2>
                                                    <p>Manual de Orientação da ECF</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="basicaEcf">
                                                <Switch
                                                    id="basicaEcf"
                                                    onChange={this.handleChange}
                                                    handleDiameter={16}
                                                    onColor="#A8B2BF"
                                                    className={this.state.basicaEcf ? 'active disabled' : 'inactive'}
                                                    checked={this.state.basicaEcf}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false}
                                                    disabled={this.state.basicaEcf} />
                                            </label>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Inteligente (Expertise Econet)</h2>
                                                    <p>A visão do guia pelos especialistas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="inteligenteEcf">
                                                <Switch
                                                    id="inteligenteEcf"
                                                    onChange={this.handleChange}
                                                    handleDiameter={16}
                                                    onColor="#6EA6E8"
                                                    className={this.state.inteligenteEcf ? 'active' : 'inactive'}
                                                    checked={this.state.inteligenteEcf}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false} />
                                            </label>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
						{/* Descomentar quando o projeto ECD entrar em produção */}
                        <Col md={6}>
                            <Card className="parametrosBox">
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <h1>ECD</h1>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Básica (Guia)</h2>
                                                    <p>Manual de Orientação da ECD</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="basicaEcd">
                                                <Switch
                                                    id="basicaEcd"
                                                    onChange={this.handleChange}
                                                    handleDiameter={16}
                                                    onColor="#A8B2BF"
                                                    className={this.state.basicaEcd ? 'active disabled' : 'inactive'}
                                                    checked={this.state.basicaEcd}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false}
                                                    disabled={this.state.basicaEcd} />
                                            </label>
                                        </Col>
                                    </Row>
                                    <Row className="parametrosLine">
                                        <Col md={10}>
                                            <Row>
                                                <Col md={12}>
                                                    <h2>Validação Inteligente (Expertise Econet)</h2>
                                                    <p>A visão do guia pelos especialistas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={2}>
                                            <label className="inteligenteEcd">
                                                <Switch
                                                    id="inteligenteEcd"
                                                    onChange={this.handleChange}
                                                    handleDiameter={16}
                                                    onColor="#6EA6E8"
                                                    className={this.state.inteligenteEcd ? 'active' : 'inactive'}
                                                    checked={this.state.inteligenteEcd}
                                                    uncheckedIcon={false}
                                                    width={45}
                                                    height={22}
                                                    checkedIcon={false} />
                                            </label>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <section className="buttonBox">
                                <button className={`ecobtn fat vazado ${isSimulacao ? 'cinza' : 'vermelho'}`} onClick={this.context.router.history.goBack} disabled={isSimulacao}>Cancelar</button>
                                <button className={`ecobtn fat ${isSimulacao ? 'cinza' : 'baby-blue'}`} onClick={this.salvarInformacoes} disabled={isSimulacao || isPro}>Salvar</button>
                            </section>
                        </Col>
                    </Row>
                </Container>
                <Modal id="modal-parametros" isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader onClick={this.toggle}><i className="fas fa-times"></i></ModalHeader>
                    <ModalBody>
                        <Container>
                            <Row>
                                <Col>
                                    <img src="/img/ecoicos/ecoico-ok.svg" alt="Sucesso" />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {this.state.modalMessage}
                                </Col>
                            </Row>
                            <Row className="boxBts">
                                <Col>
                                    <Button className="float-right ecobtn fat vazado baby-blue" onClick={this.toggle}>Ok</Button>
                                </Col>
                            </Row>
                        </Container>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default ParametrosAuditoria;


// WEBPACK FOOTER //
// ./src/Componente/ParametrosAuditoria/ParametrosAuditoria.jsx